import { Button, View } from "@/components/ui";
// import { ArrowLeft } from "@/components/shared/icons";
// import { Link } from "@/components/shared/link";
import { InfoCard } from "@/components/shared/info-card";
import { ModalRemoveCard } from "@/containers/profile/payment/modal-remove-card";
import type { PaymentScreeProps } from "..";
import { PaymentCardScreen } from "../payment-card-screen";
import { Typography } from "@/components/shared/typography";
import { AutoPayWidget } from "@/components/shared/invoices/auto-pay";
import { useInvoiceState } from "@/store/invoices";
import { cn } from "@/lib/utils";
import { IfElse } from "@/components/shared/if-else";
import { PaymentMethodScreenModal } from "@/types/invoice";
import { IconButton } from "@/components/ui/icon-button";
import { StripeCardBrandsEnum } from "@/__generated__/graphql";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export const PaymentScreen = ({
  handleRemoveConfirmation,
  loading,
  onDeleteCard,
  paymentMethod,
  infoCardDesc,
  handleCloseRemoveConfirmation,
  openRemoveConfirmation,
  setOpenRemoveConfirmation,
  creditCardPayment,
  onPay,
}: PaymentScreeProps) => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  const {
    data: { creditCardScreenModal },
    showPaymentMethodModal,
  } = useInvoiceState();

  const handleClick = () => {
    showPaymentMethodModal(PaymentMethodScreenModal.SELECT_PAYMENT);
  };

  return (
    <>
      <View
        className={cn(
          creditCardScreenModal ? "p-0" : "p-4",
          "z-10 h-full flex-1 md:p-0",
        )}
      >
        <View className="mb-4 border-b pb-4 md:mb-8">
          <IfElse
            if={creditCardScreenModal}
            else={
              <View className="flex flex-row items-center gap-2 md:p-0">
                {/* CONSISTENECY PROBLEM <Link href="/profile">
                  <ArrowLeft className="visible size-5" />
                </Link> */}
                <IconButton
                  variant={isMobile ? "ghost" : "secondary"}
                  color="foreground"
                  iconName="arrowLeft"
                  rounded="full"
                  className="p-0 md:hidden md:px-3 md:py-2"
                  onClick={() => push({ pageKey: "profile" })}
                />
                <Typography variant="label-md">Your Card Payment</Typography>
              </View>
            }
          >
            <View className="flex flex-row items-center">
              <IconButton
                iconName="arrowLeft"
                color="foreground"
                onClick={handleClick}
                variant="tertiary"
              />
              <Typography variant="body-md">Your Card Payment</Typography>
            </View>
          </IfElse>
        </View>

        <View className="mb-8 flex flex-col items-center gap-4 md:mb-0">
          {!!paymentMethod && (
            <PaymentCardScreen paymentCard={paymentMethod} loading={loading} />
          )}

          <AutoPayWidget />

          <InfoCard description={infoCardDesc} />
        </View>

        {!!paymentMethod && !creditCardPayment && (
          <Button
            variant="secondary"
            color="CTA2"
            size="lg"
            onClick={handleRemoveConfirmation}
            className="mt-4 md:ml-auto"
            disabled={loading}
            children="Remove Credit Card"
          />
        )}
        {creditCardPayment && (
          <View className="mt-4">
            {paymentMethod?.brand === StripeCardBrandsEnum.Visa && (
              <View className="flex flex-row gap-2">
                <Typography variant="body-sm" color="danger">
                  We're unable to process payments with Visa. Please update your
                  card or use PayNow to continue.
                </Typography>
              </View>
            )}
            <Button
              variant="primary"
              color="CTA"
              size="lg"
              onClick={onPay}
              disabled={
                loading || paymentMethod?.brand === StripeCardBrandsEnum.Visa
              }
              children="Pay"
              className="md:ml-auto"
            />
          </View>
        )}
      </View>

      <ModalRemoveCard
        onClose={handleCloseRemoveConfirmation}
        onDeleteCard={onDeleteCard}
        open={openRemoveConfirmation}
        setOpenRemoveConfirmation={setOpenRemoveConfirmation}
      />
    </>
  );
};
